import { Dialog, DialogContent } from "common/components/ui/Dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import { typedObjectEntries } from "common/helpers/utils";
import type { Campaign } from "common/types";

import { MANAGE_CAMPAIGNS_ACTIONS } from "../../../constants";
import CampaignsActions from "./CampaignsActions";

import type { Dispatch, ReactNode, SetStateAction } from "react";

interface DesktopDropdownProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
  selectedCampaigns: Campaign[];
  action: keyof typeof MANAGE_CAMPAIGNS_ACTIONS;
  setAction: Dispatch<SetStateAction<keyof typeof MANAGE_CAMPAIGNS_ACTIONS>>;
  onClose: () => void;
}

export default function DesktopDropdown({
  isOpen,
  setIsOpen,
  action,
  children,
  selectedCampaigns,
  setAction,
  onClose,
}: DesktopDropdownProps) {
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
        <DropdownMenuContent className="min-w-[var(--radix-popper-anchor-width)]">
          <DropdownMenuList>
            {typedObjectEntries(MANAGE_CAMPAIGNS_ACTIONS).map(
              ([key, { label, icon: Icon }]) => (
                <DropdownMenuItem
                  key={key}
                  onClick={() => {
                    setAction(key);
                    setIsOpen(true);
                  }}
                >
                  <Icon weight="fill" />
                  {label}
                </DropdownMenuItem>
              ),
            )}
          </DropdownMenuList>
        </DropdownMenuContent>
      </DropdownMenu>

      {!!action && (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogContent>
            <CampaignsActions
              action={action}
              selectedCampaigns={selectedCampaigns}
              onBack={() => setIsOpen(false)}
              onClose={onClose}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
